import React, { useContext, useState, useEffect } from "react";
import {
  Container,
  Table,
  Badge,
  Button,
  Modal,
  Card,
  Spinner,
} from "react-bootstrap";
import "../../../assets/css/admin/topuprequest/topUpRequestInAdmin.css";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const TopUpRequestInAdmin = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [requests, setRequests] = useState([]);
  const [shop, setShop] = useState("");
  const [seller, setSeller] = useState("");
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("");
  const [image, setImage] = useState(null);
  const [showProofModal, setShowProofModal] = useState(false);
  const [status, setStatus] = useState("Pending");
  const [file, setFile] = useState(null);
  const [idToUpdateDeleteTopup, setIdToUpdateDeleteTopup] = useState("");
  const [addTopupLoading, setAddTopupLoading] = useState(false);
  const [loadingApproveId, setLoadingApproveId] = useState(null);
  const [loadingRejectId, setLoadingRejectId] = useState(null);
  const [showView, setShowView] = useState(false);
  const [selected, setSelected] = useState(null);
  const getFileUrl = (file) => {
    if (!file) return "";

    if (String(file).startsWith("http")) {
      return file;
    }

    return `${baseUrlForFiles}${String(file).startsWith("/") ? "" : "/"}${file}`;
  };

  // ✅ NEW — sirf file ka naam nikalta hai (poora lamba path nahi),
  // taake box ke andar overlap na ho
  const getFileName = (file) => {
    if (!file) return "";
    const parts = String(file).split("/");
    return parts[parts.length - 1];
  };

  const viewAllUploadedTopup = () => {
    axios
      .get(`${baseUrl}/admin/topuprequest/viewAllUploadedTopuprequest`)
      .then((response) => {
        console.log(response.data);
        setRequests(response.data.requests || []);
      })
      .catch((error) => {
        console.log(error.response?.data);
        setRequests([]);
      });
  };
 const updateTopupStatus = (id, status) => {
  if (status === "Approved") {
    setLoadingApproveId(id);
  } else {
    setLoadingRejectId(id);
  }

  axios
    .post(`${baseUrl}/admin/topuprequest/updateStatus`, {
      id: id,
      status: status,
    })
    .then((response) => {
      console.log("Top Up Status Response:", response.data);

      if (response.data.success) {
        viewAllUploadedTopup();

        Swal.fire({
          icon: "success",
          title: status === "Approved" ? "Approved" : "Rejected",
          text: response.data.message,
        });
      }
    })
    .catch((error) => {
      console.log(
        "Top Up Status Error:",
        error.response?.data || error
      );

      Swal.fire({
        icon: "error",
        title: "Oops",
        text:
          error.response?.data?.message ||
          "Unable to update top up status.",
      });
    })
    .finally(() => {
      setLoadingApproveId(null);
      setLoadingRejectId(null);
    });
};

  const openView = (item) => {
    setSelected(item);
    setShowView(true);
  };
  useEffect(() => {
    viewAllUploadedTopup();
  }, []);

  return (
    <AdminMasterLayout>
      <Container fluid className="topup-container">
        <h4>Wallet Top-Up Requests</h4>
        <p className="sub-text">Approve or reject seller wallet top-ups</p>

        <Card>
          <Card.Body className="p-0">
            <div className="table-responsive">
              <Table hover className="mb-0">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Shop ID</th>
                    <th>Shop Name</th>
                    <th>Amount</th>
                    <th>Method</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {requests?.map((r, i) => (
                    <tr key={i}>
                      <td>{r.id}</td>

                      <td>{r.tpshop?.id}</td>

                      <td>
                        <div className="fw-semibold">
                          {r.tpshop?.shopname ||
                            r.tpshop?.businessName ||
                            "N/A"}
                        </div>
                        <small className="text-muted">
                          {r.tpshop?.fullName || ""}
                        </small>
                      </td>

                      <td className="fw-bold">{r.amount}</td>

                      <td>
                        <Badge className="method-badge">{r.method}</Badge>
                      </td>

                      <td>
                        <Badge
                          bg={r.status === "Pending" ? "warning" : "success"}
                        >
                          {r.status}
                        </Badge>
                      </td>

                      <td style={{ whiteSpace: "nowrap" }}>
                        {/* Eye Button */}
                        <Button
                          size="sm"
                          variant="light"
                          className="me-2 eye-btn"
                          // onClick={() => openView(r)}
                          onClick={() => {
                            setSelected(r);
                            setShowView(true);
                          }}
                        >
                          view
                        </Button>

                        {r.status === "Pending" && (
                          <>
                            <Button
                              size="sm"
                              className="approve-btn me-2"
                              disabled={loadingApproveId === r.id}
                              onClick={() =>
                                updateTopupStatus(r.id, "Approved")
                              }
                            >
                              {loadingApproveId === r.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                "✓ Approve"
                              )}
                            </Button>

                            <Button
                              size="sm"
                              className="reject-btn"
                              disabled={loadingRejectId === r.id}
                              onClick={() =>
                                updateTopupStatus(r.id, "Rejected")
                              }
                            >
                              {loadingRejectId === r.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                "✕ Reject"
                              )}
                            </Button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>

        {/* VIEW MODAL */}
        <Modal show={showView} onHide={() => setShowView(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>{selected?.id} - Top-Up Request</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selected && (
              <>
                <div className="detail-row">
                  <span>Shop</span>
                  <span>{selected.tpshop?.shopname}</span>
                </div>

                <div className="detail-row">
                  <span>Amount</span>
                  <span className="fw-bold">{selected.amount}</span>
                </div>

                <div className="detail-row">
                  <span>Method</span>
                  <Badge className="method-badge">{selected.method}</Badge>
                </div>

                {/* ✅ NEW — Bank / Wallet detail bhi yahan dikha di */}
                <div className="detail-row">
                  <span>Bank / Account</span>
                  <span className="fw-bold">
                    {selected.bank_or_wallet || "—"}
                  </span>
                </div>

                {/* ==========================================
                    ✅ FIX — File Box
                    Pehle lambi filename "View" button ke upar
                    overlap ho rahi thi (jaisa screenshot me tha).
                    Ab:
                    - sirf file ka naam dikhta hai (poora path nahi)
                    - naam ellipsis (...) se truncate hota hai
                    - button hamesha apni fixed jagah pe rehta hai
                    - "View" click karne par proof isi popup ke
                      andar (doosri chhoti modal me) khulti hai,
                      kahin bahar navigate nahi hota
                ========================================== */}
                <div
                  className="mt-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                    padding: "10px 12px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    background: "#f8f9fa",
                    overflow: "hidden",
                  }}
                >
                  <div style={{ minWidth: 0, maxWidth: "260px" }}>
                    <strong
                      style={{
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        wordBreak: "normal",
                        maxWidth: "260px",
                      }}
                      title={getFileName(selected.image)}
                    >
                      {getFileName(selected.image) || "No file uploaded"}
                    </strong>
                    <div className="text-muted small">Payment proof</div>
                  </div>

                  {selected.image && (
                    <Button
                      size="sm"
                      style={{ flexShrink: 0, whiteSpace: "nowrap" }}
                      onClick={() => {
                        setShowView(false);
                        setShowProofModal(true);
                      }}
                    >
                      View
                    </Button>
                  )}
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
        {/* PAYMENT PROOF MODAL */}
        <Modal
          show={showProofModal}
          onHide={() => {
            // ✅ FIX — proof modal band karte hi wapas detail
            // modal khul jaye, poori flow popup ke andar hi rahe
            setShowProofModal(false);
            setShowView(true);
          }}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Payment Proof</Modal.Title>
          </Modal.Header>

          <Modal.Body className="text-center">
            {selected?.image ? (
              <img
                src={getFileUrl(selected.image)}
                alt="Payment Proof"
                className="img-fluid rounded"
                style={{
                  maxHeight: "500px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            ) : (
              <p>No image found</p>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </AdminMasterLayout>
  );
};

export default TopUpRequestInAdmin;